'use client';

import {useContext} from 'react';
import {termDescriptionContext} from 'features/terms/term-provider';
import {useTranslation} from 'react-i18next';
import {Switch} from '@digdir/designsystemet-react';
import {createUseStyles} from 'react-jss';
import {getEnv} from 'environment/public.environment';

const useStyles = createUseStyles(
  {
    container: {
      marginTop: '1.5rem',
      marginBottom: '0.5rem',

      '@media print': {
        display: 'none',
      },
    },
    toggle: {
      display: 'inline-grid',
    },
    description: {
      marginTop: '0rem',
    },
  },
  {name: 'TermDescriptionSwitch'}
);

export const TermDescriptionsSwitch = () => {
  const {
    descriptions: {setVisibility, visible},
  } = useContext(termDescriptionContext);
  const {t} = useTranslation(['common']);

  const styles = useStyles();

  if (!getEnv().features.fellesDatakatalog) {
    return null;
  }

  return (
    <div className={styles.container} aria-hidden={true}>
      <Switch
        checked={visible}
        className={styles.toggle}
        onChange={e => {
          setVisibility(e.target.checked);
        }}
        label={t('common:term_explanations')}
      />
      <p className={styles.description}>{t('common:term_explanations_desc')}</p>
    </div>
  );
};
